import Heading from '../../../../components/Layouts/Heading';
import { useHasScope } from '../../../accounts/accountsQueries';
import HubspotPlaylistsAdminList from './HubspotPlaylistsAdminList';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ApiError from '../../../../components/Errors/ApiError';
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../../../constants/Navigation';
import { PlaylistBackButton, Subheader } from '../../../savedItems/components/PlaylistPageHeader';
import { View } from 'foundations-components/components/View';
import { ACADEMY_PAGE_MAX_WIDTH } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubspotPlaylistsAdmin = () => {
  const {
    hasScope: hasPublicPlaylistsAdminScope
  } = useHasScope('academy-public-playlists-admin');
  if (!hasPublicPlaylistsAdminScope) {
    return /*#__PURE__*/_jsx(ApiError, {});
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, {
      subtitle: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HelpIcon, {
          color: "icon-primary-default",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.hubspotPlaylists.admin.subtitleHelpIcon"
          })
        }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.hubspotPlaylists.admin.subtitle"
        })]
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.hubspotPlaylists.admin.heading"
      })
    }), /*#__PURE__*/_jsx(Subheader, {
      children: /*#__PURE__*/_jsx(PlaylistBackButton, {
        exact: true,
        to: MY_PLAYLISTS_URL_FRAGMENT,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.myPlaylists"
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      marginInline: "auto",
      maxInlineSize: `${ACADEMY_PAGE_MAX_WIDTH}px`,
      overflow: "hidden",
      paddingBlock: "1100",
      paddingInline: "400",
      children: /*#__PURE__*/_jsx(HubspotPlaylistsAdminList, {})
    })]
  });
};
export default HubspotPlaylistsAdmin;